import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

/**
 * The clock and battery are drawn by iOS, over our background, and iOS will not work out
 * which colour they should be. Unset, a dark app gets black text on black.
 *
 * `Style.Dark` means "dark content"… no: in this plugin `Style.Dark` means the bar renders
 * for a DARK background, i.e. light text. The naming has bitten enough people that it is
 * written out here rather than left to a reader's memory.
 */
const supported = Capacitor.isNativePlatform();

export const statusBar = {
  /** Light text — use on a dark background. */
  useLightContent() {
    if (supported) void StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
  },
  /** Dark text — use on a light background. */
  useDarkContent() {
    if (supported) void StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  },
  /** Follow the OS appearance. The app's own theme should usually decide instead. */
  followSystem() {
    if (supported) void StatusBar.setStyle({ style: Style.Default }).catch(() => {});
  },
  /**
   * Binds the bar to the app's own appearance.
   *
   * Buddy renders DARK whatever the phone is set to — `index.html` puts `.dark` on the
   * document and commits to it (BUD-274). The status bar has to agree, or a phone in
   * light mode shows a black clock on the app's black background. Following the OS here
   * would be following something the app deliberately does not follow.
   *
   * ⚠️ The timer screen is full-bleed and paints its OWN background — near-black when
   * self-paced, green or rust while phase-driven, and a heart-rate zone colour when a
   * strap is connected. Every one of those is dark, so light content stays correct there
   * too and the timer needs no call of its own. A LIGHT full-bleed screen would.
   */
  bindToColorScheme(): () => void {
    if (!supported) return () => {};
    statusBar.useLightContent();
    return () => {};
  },
};
